(() => {
  function initProductCardOptionScroll(root = document) {
    const wraps = root.querySelectorAll('.itc-pcard-option-scroll-wrap');

    wraps.forEach((wrap) => {
      if (wrap.dataset.itcScrollReady === 'true') return;
      wrap.dataset.itcScrollReady = 'true';

      const viewport = wrap.querySelector('.itc-pcard-option-scroll-viewport');
      const scroller = wrap.querySelector('.itc-pcard-option-scroll');
      const prevBtn = wrap.querySelector('.itc-pcard-option-scroll-btn--prev');
      const nextBtn = wrap.querySelector('.itc-pcard-option-scroll-btn--next');

      if (!viewport || !scroller || !prevBtn || !nextBtn) return;

      const setLayoutVars = () => {
        const wrapWidth = wrap.clientWidth;
        if (!wrapWidth) return;

        const gap = wrapWidth < 170 ? 2 : 4;
        const arrowSize = Math.max(16, Math.min(20, Math.round(wrapWidth * 0.1)));

        let optionSize;

        if (wrapWidth < 150) {
          optionSize = 30;
        } else if (wrapWidth < 190) {
          optionSize = 34;
        } else {
          optionSize = 36;
        }

        const rectWidth = Math.round(optionSize * 1.6);
        const rectHeight = Math.round(optionSize * 0.78);

        wrap.style.setProperty('--itc-option-size', `${optionSize}px`);
        wrap.style.setProperty('--itc-option-gap', `${gap}px`);
        wrap.style.setProperty('--itc-arrow-size', `${arrowSize}px`);
        wrap.style.setProperty('--itc-arrow-gap', '4px');
        wrap.style.setProperty('--itc-rect-width', `${rectWidth}px`);
        wrap.style.setProperty('--itc-rect-height', `${rectHeight}px`);
      };

      const updateButtons = () => {
        setLayoutVars();

        /*
          这里用 requestAnimationFrame 再读一次尺寸，
          避免 CSS 变量刚写入后立刻读取 scrollWidth/clientWidth 不准。
        */
        requestAnimationFrame(() => {
          const maxScrollLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
          const hasOverflow = maxScrollLeft > 2;

          wrap.classList.toggle('has-overflow', hasOverflow);

          if (!hasOverflow) {
            prevBtn.hidden = true;
            nextBtn.hidden = true;

            prevBtn.disabled = true;
            nextBtn.disabled = true;

            prevBtn.classList.add('is-disabled');
            nextBtn.classList.add('is-disabled');
            return;
          }

          const isAtStart = scroller.scrollLeft <= 2;
          const isAtEnd = scroller.scrollLeft >= maxScrollLeft - 2;

          /*
            最左边：左按钮隐藏，右按钮显示
            中间：左右都显示
            最右边：左按钮显示，右按钮显示但禁用
          */
          prevBtn.hidden = isAtStart;
          nextBtn.hidden = false;

          prevBtn.disabled = isAtStart;
          nextBtn.disabled = isAtEnd;

          prevBtn.classList.toggle('is-disabled', isAtStart);
          nextBtn.classList.toggle('is-disabled', isAtEnd);
        });
      };

      const getStep = () => {
        const item = scroller.querySelector('.m-product-option--node, .m-product-option--more-option');

        if (!item) return scroller.clientWidth * 0.8;

        const styles = window.getComputedStyle(scroller);
        const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;

        return item.getBoundingClientRect().width + gap;
      };

      prevBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (prevBtn.disabled) return;

        scroller.scrollBy({
          left: -getStep(),
          behavior: 'smooth',
        });

        setTimeout(updateButtons, 250);
      });

      nextBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (nextBtn.disabled) return;

        scroller.scrollBy({
          left: getStep(),
          behavior: 'smooth',
        });

        setTimeout(updateButtons, 250);
      });

      scroller.addEventListener(
        'scroll',
        () => {
          requestAnimationFrame(updateButtons);
        },
        { passive: true }
      );

      window.addEventListener('resize', updateButtons);

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => {
          updateButtons();
        });

        resizeObserver.observe(wrap);
        resizeObserver.observe(viewport);
        resizeObserver.observe(scroller);
      }

      requestAnimationFrame(updateButtons);
      setTimeout(updateButtons, 300);
      setTimeout(updateButtons, 800);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initProductCardOptionScroll();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initProductCardOptionScroll(event.target);
  });

  document.addEventListener('shopify:section:select', (event) => {
    initProductCardOptionScroll(event.target);
  });
})();